export default __webpack_public_path__ + "img/Googleroadmap-ca129fe641a8fd9386cafb61db6a0472.png";